module.exports = __webpack_public_path__ + "img/new-x-axis-loe.7d9434bd.svg";